import { Object3D } from "three"
import type { HasDisposeOrTraverse, Nullable } from "../../../typescript"
import disposeForTraverse from "./disposeForTraverse"

export default function disposeRecursive (obj : Nullable<HasDisposeOrTraverse>): void {
  if (obj) {
    if (obj instanceof Object3D) {
      // obj.dispatchEvent({ type: 'removed' })
      obj.traverse(disposeForTraverse)
      // obj.removeFromParent()
    }
    if ('removeFromParent' in obj) {
      obj.removeFromParent()
    }
    if (obj instanceof Object3D) {
      disposeForTraverse(obj)
    }
    if ('dispose' in obj) {
      obj.dispose()
    }
  }
}